export const isValidDate = (value) => {
  if (value == null) return true;
  let dateString;
  // Si el valor es un objeto `Date`, formatearlo
  if (value instanceof Date) {
    const day = value.getDate().toString().padStart(2, "0");
    const month = (value.getMonth() + 1).toString().padStart(2, "0");
    const year = value.getFullYear();
    dateString = `${day}/${month}/${year}`;
  } else if (typeof value === "string") {
    // Si ya es una cadena, usarla directamente
    dateString = value;
  } else {
    return false; // No es válido si no es `Date` ni `string`
  }
  // Verificar que el valor sea una cadena
  if (typeof dateString !== "string") {
    return false;
  }
  const [day, month, year] = dateString.split("/").map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};
